/* eslint-disable import/prefer-default-export */
import axios from '@/api';

// get all user
function getClassi() {
  return axios.get('teacher/classrooms', {})
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

export const classiService = {
  getClassi,
};
